import { IContrat } from '@/service/club/types';

export const CONTRACT_FIELD_LABELS: Record<string, string> = {
  numero_contrato: 'N.º Contrato',
  codigo_contrato: 'N.º Contrato',
  nome_servico: 'Serviço',
  nome_contrato: 'Nome do Contrato',
  valor_servico: 'Valor',
  status_servico: 'Status do Serviço',
  contrato_assinado: 'Contrato Assinado',
  data_assinatura_contrato: 'Data de Assinatura do Contrato',
  data_contrato: 'Data do Contrato',
  adesao: 'Data de Assinatura do Contrato',
  observacao: 'Observação',
};

const CONTRACT_FIELD_ORDER = [
  'numero_contrato',
  'codigo_contrato',
  'nome_servico',
  'nome_contrato',
  'valor_servico',
  'status_servico',
  'contrato_assinado',
  'data_assinatura_contrato',
  'adesao',
  'data_contrato',
  'observacao',
];

// link e produtos são exibidos separadamente no card (hyperlink e lista)
const CONTRACT_FIELD_SKIP = ['link', 'produtos'];

export function getContractDisplayFields(
  contrato: IContrat | Record<string, unknown>
): { key: string; label: string; value: string }[] {
  const fields: { key: string; label: string; value: string }[] = [];
  const obj = contrato as Record<string, unknown>;

  const skipIf = (key: string, preferKey: string) =>
    obj[preferKey] != null && obj[preferKey] !== '' && key !== preferKey;

  for (const key of CONTRACT_FIELD_ORDER) {
    if (key === 'id_cliente_servico') continue;
    if (CONTRACT_FIELD_SKIP.includes(key)) continue;
    if (skipIf(key, 'numero_contrato') && key === 'codigo_contrato') continue;
    if (skipIf(key, 'data_assinatura_contrato') && key === 'adesao') continue;

    const raw = obj[key];
    if (raw === null || raw === undefined || raw === '') continue;

    const label = CONTRACT_FIELD_LABELS[key] || key;
    let value: string;
    if (key === 'valor_servico') {
      value = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(Number(raw));
    } else if (key === 'contrato_assinado') {
      value = raw ? 'Sim' : 'Não';
    } else {
      value = String(raw);
    }
    fields.push({ key, label, value });
  }

  const remaining = Object.entries(obj).filter(
    ([k, v]) =>
      v != null &&
      v !== '' &&
      !CONTRACT_FIELD_ORDER.includes(k) &&
      !CONTRACT_FIELD_SKIP.includes(k) &&
      k !== 'id_cliente_servico' &&
      !Array.isArray(v)
  );
  for (const [key, raw] of remaining) {
    const label = CONTRACT_FIELD_LABELS[key] || key.replace(/_/g, ' ');
    let value: string;
    if (typeof raw === 'number' && key.toLowerCase().includes('valor')) {
      value = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(raw);
    } else if (typeof raw === 'boolean') {
      value = raw ? 'Sim' : 'Não';
    } else {
      value = String(raw);
    }
    fields.push({ key, label, value });
  }
  return fields;
}
